import React, { Component } from 'react';
import { TabView, TabPanel } from 'primereact/tabview';
import CatGrid from '../CatGrid';
import CatPanel from '../CatPanel';
import { LogGrid } from '../LogGrid';
import { useTranslation

 } from 'react-i18next';
export function CoursePane(props)
{
  const {t}=useTranslation();

  const catAdded = (cat)=>{
    props.catAdded(cat);
  }
  const catChanged = (cat)=>{
    props.catChanged(cat);
  }
  const catDeleted = (cat)=>{
    props.catDeleted(cat);
  }
  const openPage = (cat)=>{
    props.selectionChanged(cat);
  }
  return(
    <React.Fragment>
      <CatPanel cat={props.cat} openPage={openPage}/>
      <TabView className='flex-1 flex flex-column overflow-hidden'>
        <TabPanel header={t("Topics")}>
          <CatGrid parentCat={props.cat} mode="CHILD" catType="TOPIC" catAdded={catAdded} catChanged={catChanged} catDeleted={catDeleted} openPage={openPage}/>
        </TabPanel>
        <TabPanel header={t("Outcomes")}>
          <CatGrid parentCat={props.cat} mode="CHILD" catType="OUTCOME" catAdded={catAdded} catChanged={catChanged} catDeleted={catDeleted} openPage={openPage}/>
        </TabPanel>
        <TabPanel header={t("Skills")}>
          <CatGrid parentCat={props.cat} mode="CHILD" catType="SKILL" catAdded={catAdded} catChanged={catChanged} catDeleted={catDeleted} openPage={openPage}/>
        </TabPanel>
        <TabPanel header={t("History")}>
          <LogGrid catId={props.cat.id}/>
        </TabPanel>
      </TabView>
    </React.Fragment>
  )  
}

export default CoursePane;
